import type { Homework } from '../services/homework'
import submissionIconMark from '../assets/icon/submission-icon-mark.svg'

const typeLabel: Record<string, string> = { system: 'システム', entre: 'アントレ部', school: '学校' }

interface HomeworkHeaderProps {
  homework: Homework
  // true when the header sits inside a white panel instead of on the gradient: the title
  // turns dark and the white pieces (chip, description box) need an outline to show up.
  onWhite?: boolean
}

const HomeworkHeader = ({ homework, onWhite = false }: HomeworkHeaderProps) => {
  return (
    <div className={`w-full max-w-6xl mx-auto ${onWhite ? 'pb-1' : 'px-4 pt-6 pb-1'}`}>
      {/* Title row — the bottom margin is only needed when the description box follows */}
      <div className={`flex items-start gap-3 ${homework.description ? 'mb-3' : ''}`}>
        {/* Icon badge */}
        <img src={submissionIconMark} alt="" className="flex-shrink-0 mt-0.5" style={{ width: 45, height: 40 }} />
        {/* Title — self-centered relative to icon */}
        <h1 className={`flex-1 text-xl font-bold leading-snug self-center ${onWhite ? 'text-gray-900' : 'text-white'}`}>
          {homework.title}
        </h1>
        {/* Type chip + deadline — horizontal row, matching Figma */}
        <div className="flex-shrink-0 flex items-center gap-3 self-center">
          <span className={`px-6 py-2 rounded-full text-[#da4574] text-sm font-bold whitespace-nowrap ${onWhite ? 'bg-[#fff0f4]' : 'bg-white'}`}>
            {typeLabel[homework.type] || homework.type}
          </span>
          <div className="px-4 py-2 rounded-full bg-[#fff0f4] flex items-center gap-1.5 text-sm whitespace-nowrap">
            <span className="font-bold text-[#72727c]">締切</span>
            <span className="text-[#72727c]">
              {homework.deadline_at
                ? new Date(homework.deadline_at).toLocaleDateString('ja-JP', { month: 'numeric', day: 'numeric' })
                : '未設定'}
            </span>
          </div>
        </div>
      </div>

      {/* Description in white box */}
      {homework.description && (
        <div className={`bg-white rounded-xl px-4 py-3 ${onWhite ? 'border border-gray-200' : 'shadow-sm'}`}>
          <p className="text-sm text-gray-600 leading-relaxed">{homework.description}</p>
        </div>
      )}
    </div>
  )
}

export default HomeworkHeader
